import React, { useCallback, useEffect } from "react";
import { observer } from "mobx-react";
import { SaveFormButton } from "../buttons/SaveFormButton";
import { CancelFormButton } from "../buttons/CancelFormButton";
import { CloseFormButton } from "../buttons/CloseFormButton";
import { PrintFormButton } from "../buttons/PrintFormButton";
import { EditFormButton } from "../buttons/EditFormButton";
import { Grid } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import StickyBox from "react-sticky-box";

export type FormToolboxProps = {
  saveForm?: () => void;
  /** Guardar deshabilitado: mientras se guarda, un segundo clic no hace nada. */
  saveDisabled?: boolean;
  saveAndCloseLabel?: string;
  saveAndCloseLabelTooltip?: string;
  cancelForm?: () => void;
  cancelLabel?: string;
  cancelLabelTooltip?: string;
  closeForm?: () => void;
  closeLabel?: string;
  closeLabelTooltip?: string;
  printForm?: () => void;
  printLabel?: string;
  printLabelTooltip?: string;
  editForm?: () => void;
  editLabel?: string;
  editLabelTooltip?: string;
};

export const FormToolbox: React.FC<FormToolboxProps> = observer(
  ({
    saveForm,
    saveDisabled,
    saveAndCloseLabel,
    saveAndCloseLabelTooltip,
    cancelForm,
    cancelLabel,
    cancelLabelTooltip,
    closeForm,
    closeLabel,
    closeLabelTooltip,
    printForm,
    printLabel,
    printLabelTooltip,
    editForm,
    editLabel,
    editLabelTooltip,
  }) => {
    const escFunction = useCallback(
      (event: any) => {
        if (closeForm && event.key === "Escape") {
          closeForm();
        }
      },
      [closeForm]
    );

    useEffect(() => {
      document.addEventListener("keydown", escFunction, false);

      return () => {
        document.removeEventListener("keydown", escFunction, false);
      };
    }, [escFunction]);

    let saveFormTool;
    if (saveForm) {
      saveFormTool = (
        <Tooltip title={saveAndCloseLabelTooltip} placement="bottom" arrow>
          <div>
            <SaveFormButton
              onClick={() => saveForm()}
              label={saveAndCloseLabel}
              disabled={saveDisabled}
            />
          </div>
        </Tooltip>
      );
    }

    let printFormTool;
    if (printForm) {
      printFormTool = (
        <Tooltip title={printLabelTooltip} placement="bottom" arrow>
          <div>
            <PrintFormButton onClick={() => printForm()} label={printLabel} />
          </div>
        </Tooltip>
      );
    }

    let editFormTool;
    if (editForm) {
      editFormTool = (
        <Tooltip title={editLabelTooltip} placement="bottom" arrow>
          <div>
            <EditFormButton onClick={() => editForm()} label={editLabel} />
          </div>
        </Tooltip>
      );
    }

    let cancelFormTool;
    if (cancelForm) {
      cancelFormTool = (
        <Tooltip title={cancelLabelTooltip} placement="bottom" arrow>
          <div>
            <CancelFormButton
              onClick={() => cancelForm()}
              label={cancelLabel}
            />
          </div>
        </Tooltip>
      );
    }

    let closeFormTool;
    if (closeForm) {
      closeFormTool = (
        <Tooltip title={closeLabelTooltip} placement="bottom" arrow>
          <div>
            <CloseFormButton onClick={() => closeForm()} label={closeLabel} />
          </div>
        </Tooltip>
      );
    }

    return (
      <StickyBox offsetTop={0} offsetBottom={0} style={{ zIndex: 10 }}>
        <Grid container sx={{ backgroundColor: "background.paper" }}>
          <Grid container>
            <Grid style={{ display: "flex", alignItems: "center" }}>
              {saveFormTool}
            </Grid>
            <Grid style={{ display: "flex", alignItems: "center" }}>
              {editFormTool}
            </Grid>
            <Grid style={{ display: "flex", alignItems: "center" }}>
              {printFormTool}
            </Grid>
            <Grid style={{ display: "flex", alignItems: "center" }}>
              {cancelFormTool}
            </Grid>
            <Grid style={{ display: "flex", alignItems: "center" }}>
              {closeFormTool}
            </Grid>
          </Grid>
        </Grid>
      </StickyBox>
    );
  }
);
